import { useState } from 'react';
import { apiClient } from 'config/api';

export interface AreaEditionBody {
  areaId: string;
  areaName: string;
  costCenter?: string;
}

/**
 * Custom hook to manage area edition.
 */
function useEditArea() {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Function to edit an area.
   * @param areaId - Area ID.
   * @param areaName - Area name.
   * @param costCenter - Area's cost center.
   */
  const editArea = async ({ areaId, areaName, costCenter }: AreaEditionBody) => {
    setIsLoading(true);
    try {
      const { data } = await apiClient.put(`/v2/partner/areas/${areaId}`, {
        area_name: areaName,
        cost_center: costCenter ? costCenter : null,
      });
      setIsLoading(false);
      return data;
    } catch (error) {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    editArea,
  };
}

export default useEditArea;
